import { jsx as x } from "react/jsx-runtime";
const d = {
  body01: "font-sans font-normal text-base",
  body02: "font-sans font-normal text-sm",
  body03: "font-sans font-normal text-xs",
  body04: "font-sans font-normal text-[11px]/[16px]",
  body05: "font-sans font-normal text-[10px]/[12px]",
  report01: "font-sans font-light text-[0.875em] mb-2_5"
}, l = {
  primary: "text-text-primary",
  secondary: "text-text-secondary"
}, y = ({
  typography: t = "body02",
  color: o = "primary",
  className: s,
  children: a,
  ...n
}) => {
  const e = d[t], r = l[o];
  return /* @__PURE__ */ x("div", { className: `${e} ${r} ${s}`, "data-testid": n["data-testid"], children: a });
};
export {
  y as default
};
//# sourceMappingURL=index.es7.js.map
